<template>
  <div>
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    ></SiruiSearch>

    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :loading="load"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :columns="columnListDefault"
        rowKey="contractNo"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnListDefault"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :formatter="item.formatter"
          :field="item.field"
          :title="item.title"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.field] | formatTableColumn(item.format) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>

<script>
  import tableMixins from '@/common/mixins/table.js';
  // import { filterEmpty, isSearchEmpty, toLine, getUserCompanyList } from '@/common/js/util';
  import COM_API from '@/api/masterData/company.js';
  import { mapState } from 'vuex';
  export default {
    name: 'list',
    mixins: [tableMixins],
    data() {
      return {
        // footerTotalCols:{amount:['contractTotalAmount'],quantity:['productQuantity']},
        query: {
          contractDepartmentNoIn: null,
          createDate: null,
          contractNo: null,
          externalContractNo: null,
          customerNoIn: null,
          contractSalesmanName: null,
          productNoList: null,
          quantityStart: undefined,
          quantityEnd: undefined,
          businessContractTotalAmountStart: undefined,
          businessContractTotalAmountEnd: undefined,
          ladingTotalQuantityStart: undefined,
          ladingTotalQuantityEnd: undefined,
          businessLadingTotalAmountStart: undefined,
          businessLadingTotalAmountEnd: undefined,
          invoiceQuantityStart: undefined,
          invoiceQuantityEnd: undefined,
          invoiceAmountStart: undefined,
          invoiceAmountEnd: undefined,
          paidAmountStart: undefined,
          paidAmountEnd: undefined,
          contractStatus: null,
          isCreditsale: null,
          shipComplete: null,
        },
        tableData: [],
        load: false,
        columnListDefault: [
          // {
          //   type: "checkbox",
          //   visible: true,
          //   width: "50",
          //   fixed: "left"
          // },
          //外部合同号
          {
            field: 'departmentCode',
            title: '部门代码',
            visible: true,
          },
          {
            field: 'departmentName',
            title: '部门名称',
            visible: true,
          },
          {
            field: 'customerNo',
            title: '客户编码',
            visible: true,
          },
          {
            field: 'customerName',
            title: '客户名称',
            visible: true,
          },
          {
            field: 'contractNo',
            title: '合同编号',
            visible: true,
          },
          {
            field: 'externalContractNo',
            title: '外部合同号',
            visible: true,
          },
          {
            field: 'contractCreateDate',
            title: '创建日期',
            visible: true,
            width: '180',
          },
          {
            field: 'contractStatus',
            title: '合同状态',
            width: '100',
            visible: true,
          },
          {
            field: 'shipComplete',
            title: '是否完全发货',
            width: '100',
            visible: true,
          },
          {
            field: 'contractSalesmanName',
            title: '业务员',
            visible: true,
          },
          {
            field: 'contractCurrency',
            title: '货币',
            visible: true,
          },
          {
            field: 'contractCurrencyExchangeRate',
            title: '汇率',
            visible: true,
          },
          {
            field: 'tradeType',
            title: '贸易类型',
            visible: true,
          },
          {
            field: 'businessType',
            title: '业务性质',
            visible: true,
          },
          {
            field: 'lastestReceiveMoneyDay',
            title: '最晚收款日',
            visible: true,
          },
          {
            field: 'lastestSendProductDay',
            title: '最晚发货日',
            visible: true,
          },
          {
            field: 'paidAmount',
            title: '收款金额（原币）',
            visible: true,
          },
          {
            field: 'paidAmountCurrency',
            title: '收款金额（本币）',
            visible: true,
          },
          {
            field: 'unpaidAmount',
            title: '未收款金额（原币）',
            visible: true,
          },
          {
            field: 'ladingDetailNo',
            title: '行项目号',
            visible: true,
          },
          {
            field: 'productNo',
            title: '商品编码',
            visible: true,
          },
          {
            field: 'productDesc',
            title: '商品描述',
            visible: true,
          },
          {
            field: 'unit',
            title: '单位',
            visible: true,
          },
          {
            field: 'productQuantity',
            title: '合同数量',
            visible: true,
          },
          {
            field: 'businessContractUnitPrice',
            title: '合同单价',
            visible: true,
            sortable: true,
          },
          {
            field: 'businessChangeUnitPrice',
            title: '变动单价',
            visible: true,
          },
          {
            field: 'businessContractTotalAmount',
            title: '合同金额',
            visible: true,
          },
          {
            field: 'businessChangeTotalAmount',
            title: '变动金额',
            visible: true,
          },
          {
            field: 'businessContractTaxAmount',
            title: '合同税额',
            visible: true,
          },
          {
            field: 'businessChangeTaxAmount',
            title: '变动税额',
            visible: true,
          },
          {
            field: 'businessContractPureAmount',
            title: '合同净值',
            visible: true,
          },
          {
            field: 'businessChangePureAmount',
            title: '变动净值',
            visible: true,
          },
          {
            field: 'shippedQuantity',
            title: '发货数量',
            visible: true,
          },
          {
            field: 'deliverAmount',
            title: '发货金额',
            visible: true,
          },
          {
            field: 'deliverTaxAmount',
            title: '发货税额',
            visible: true,
          },
          {
            field: 'deliverPureAmount',
            title: '发货净值',
            visible: true,
          },
          {
            field: 'actualSendQuantity',
            title: '物流出库数量',
            visible: true,
          },
          {
            field: 'invoiceQuantity',
            title: '开票数量',
            visible: true,
          },
          {
            field: 'invoiceAmount',
            title: '开票金额',
            visible: true,
          },
          {
            field: 'taxAmount',
            title: '开票税额',
            visible: true,
          },
          {
            field: 'excludedTaxAmount',
            title: '开票净值',
            visible: true,
          },
          {
            field: 'returnQuantity',
            title: '销售退货数量',
            visible: true,
          },
          {
            field: 'returnAmount',
            title: '销售退货金额',
            visible: true,
          },
          {
            field: 'isCreditsale',
            title: '赊销',
            visible: true,
          },
        ],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
        lang: (state) => state.lang.language,
        dict: (state) => state.dict,
      }),
      searchColumns() {
        return [
          {
            prop: 'contractDepartmentNoIn',
            name: '部门',
            type: 'treeSelect',
            apiUrl: COM_API.LIST_COMPANY_API,
            apiData: {
              tenantCode: this.userInfo.userInfo.tenantCode,
              adminFlag: this.userInfo.userInfo.adminFlag,
            },
            multiple: true,
            clearable: false,
          },
          {
            prop: 'createDate',
            name: this.$t('创建日期'),
            type: 'daterange',
          },
          {
            prop: 'contractNo',
            name: '合同编号',
            type: 'input',
          },
          {
            prop: 'externalContractNo',
            name: '外部合同号',
            type: 'input',
          },
          {
            prop: 'customerNoIn',
            name: '客户名称',
            type: 'searchTableSpec',
            searchType: 'supplier',
            extraData: {
              partnerTypes: 'HZHB03,HZHB01',
              departmentCode: this.query.ladingBusinessDepartmentNoIn,
              companyCode: this.query.ladingBusinessCompanyCodeIn
                ? this.query.ladingBusinessCompanyCodeIn.join()
                : '', //公司
            },
            isNeedMultipleValue: true,
          },
          {
            prop: 'contractSalesmanName',
            name: '业务员',
            type: 'input',
          },
          {
            prop: 'productNoList',
            name: '商品描述',
            type: 'searchTableSpec',
            searchType: 'goodsDetail',
            isNeedMultipleValue: true,
          },
          {
            type: 'inputRange',
            prop: ['quantityStart', 'quantityEnd'],
            precision: 6,
            max: 99999999999999.99,
            name: '合同数量',
          },
          {
            type: 'inputRange',
            prop: ['businessContractTotalAmountStart', 'businessContractTotalAmountEnd'],
            precision: 6,
            max: 99999999999999.99,
            name: '合同金额',
          },
          {
            type: 'inputRange',
            prop: ['ladingTotalQuantityStart', 'ladingTotalQuantityEnd'],
            precision: 6,
            max: 99999999999999.99,
            name: '提单数量',
          },
          {
            type: 'inputRange',
            prop: ['businessLadingTotalAmountStart', 'businessLadingTotalAmountEnd'],
            precision: 6,
            max: 99999999999999.99,
            name: '提单金额',
          },
          {
            type: 'inputRange',
            prop: ['invoiceQuantityStart', 'invoiceQuantityEnd'],
            precision: 6,
            max: 99999999999999.99,
            name: '开票数量',
          },
          {
            type: 'inputRange',
            prop: ['invoiceAmountStart', 'invoiceAmountEnd'],
            precision: 6,
            max: 99999999999999.99,
            name: '开票金额',
          },
          {
            type: 'inputRange',
            prop: ['paidAmountStart', 'paidAmountEnd'],
            precision: 6,
            max: 99999999999999.99,
            name: '收款金额（原币）',
          },
          {
            type: 'dictSelect',
            prop: 'contractStatus',
            name: '合同状态',
            apiData: { dictType: 'contract_request_status' },
          },
          {
            type: 'dictSelect',
            prop: 'isCreditsale',
            name: '赊销',
            apiData: { dictType: 'yes-no' },
          },
          {
            type: 'select',
            prop: 'shipComplete',
            name: '是否完全发货',
            options: [
              {
                value: 'Y',
                label: '发货完成',
              },
              {
                value: 'N',
                label: '发货未完成',
              },
              {
                value: 'YA',
                label: '发货完成审批中',
              },
              {
                value: 'NA',
                label: '发货未完成审批中',
              },
            ],
          },
        ];
      },
    },
    mounted() {
      this.getData();
    },
    methods: {
      getData() {
        this.load = true;
        let params = {
          pageSize: this.$refs.siruiTable.page.pageSize,
          pageNum: this.$refs.siruiTable.page.pageNum,
          ...this.query,
        };
        if (this.query.createDate) {
          params.contractCreateDateStart = this.query.createDate[0];
          params.contractCreateDateEnd = this.query.createDate[1];
        }
        if (this.query.contractDepartmentNoIn) {
          params.contractDepartmentNoIn = this.query.contractDepartmentNoIn.split(',');
        }
        if (this.query.customerNoIn) {
          params.customerNoIn = this.query.customerNoIn.map((item) => {
            return item.partnerCode;
          });
        }
        // if(this.query.productNoIn) {
        //   params.productNoIn = this.query.productNoIn.map(item => {return item.productDetailCode})
        // }
        this.$axios.post('/sales/order/listOrderReportByPage', params).then((res) => {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.list;
            if (this.$refs.siruiTable) {
              this.$refs.siruiTable.setPageTotal(res.data.data.total);
            }
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      resetBtnClick() {
        this.getData();
      },
    },
  };
</script>

<style scoped></style>
